module.exports = __webpack_public_path__ + "assets/audio/phoneCallExample.mp3";